"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _link = _interopRequireDefault(require("../../elements/buttons/link"));
var _card = _interopRequireDefault(require("../../elements/other/card"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const cardBreakpoint = _patternLibraryUtils.deviceMax.tablet;
const RecoreCardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RecoreCardContainer",
  class: "pl-r121kg1b",
  vars: {
    "r121kg1b-0": [({
      backgroundColor
    }) => backgroundColor ?? `${_intents.default.ux.box.backgroundColor}`],
    "r121kg1b-1": [({
      hasCta
    }) => hasCta ? 'pointer' : 'default'],
    "r121kg1b-2": [({
      landscape
    }) => landscape ? `url(${landscape})` : 'initial'],
    "r121kg1b-7": [({
      portrait
    }) => portrait ? `url(${portrait})` : 'initial']
  }
});
const RecoreCardBody = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RecoreCardBody",
  class: "pl-r1c5vpbo",
  vars: {
    "r1c5vpbo-0": [({
      cardSize
    }) => cardSize === 'sm' ? '45%' : '60%'],
    "r1c5vpbo-4": [({
      textFontSize
    }) => textFontSize],
    "r1c5vpbo-6": [({
      cardSize
    }) => cardSize === 'sm' ? '100%' : '45%'],
    "r1c5vpbo-7": [({
      hasCta,
      cardSize
    }) => hasCta && cardSize === 'lg' ? 'var(--fixed-space-300)' : 'unset']
  }
});
const RecoreCardIcon = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RecoreCardIcon",
  class: "pl-r2pzdfe"
});
const MobileArrow = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MobileArrow",
  class: "pl-mecoqb"
});
const RecoreCTA = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RecoreCTA",
  class: "pl-rnv7kak"
});

/**
 * Recore Card component.
 *
 * @param {Object} props React props
 * @param {string} props.card Card component props
 * @param {string} props.cardSize size type of the card
 * @param {string} props.cta CTA Button or Link
 * @param {string} props.icon Mobile icon type
 * @param {Object} props.landscape Desktop image url
 * @param {Object} props.portrait Mobile image url
 * @param {string} props.backgroundColor Card background color
 * @returns {React.ReactElement} RecoreCard component
 * @public
 */

function RecoreCard({
  landscape,
  portrait,
  backgroundColor,
  card = {
    padding: 'none',
    indented: true,
    textAlign: 'start',
    headlineSize: 'h4',
    className: 'card-headline'
  },
  icon,
  cardSize = 'sm',
  textFontSize = '1em',
  cta = {
    templateName: 'Link',
    external: true,
    design: 'arrow'
  }
}) {
  const cardRef = (0, _react.useRef)();
  const Arrow = /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: "arrow-right"
  });
  const hasCta = !!cta;
  const {
    ctaRef
  } = (0, _patternLibraryUtils.useTrackingUpdate)(cta);
  const handleClick = () => {
    (0, _patternLibraryUtils.getClickable)({
      ref: cardRef
    })?.click();
  };
  return /*#__PURE__*/_react.default.createElement(RecoreCardContainer, {
    ref: cardRef,
    hasCta: hasCta,
    "aria-label": hasCta ? cta.ariaLabel : null,
    "data-cy": "recore-card",
    onClick: () => handleClick(),
    landscape: landscape?.url,
    portrait: portrait?.url,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    cardSize: cardSize,
    className: `recore-card recore-card-${cardSize}`
  }, hasCta && /*#__PURE__*/_react.default.createElement(MobileArrow, {
    "data-cy": "recore-card-arrow",
    className: `recore-mobile-arrow-${cardSize}`
  }, Arrow), /*#__PURE__*/_react.default.createElement(RecoreCardBody, {
    "data-cy": "recore-card-body",
    cardSize: cardSize,
    textFontSize: textFontSize,
    hasCta: hasCta,
    className: `recore-card-body recore-card-body-${cardSize}`
  }, /*#__PURE__*/_react.default.createElement(RecoreCardIcon, null, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: icon
  })), /*#__PURE__*/_react.default.createElement(_card.default, (0, _extends2.default)({
    padding: "none",
    indented: true,
    textAlign: "start"
  }, card, {
    className: "recore-card-headline"
  }))), hasCta && /*#__PURE__*/_react.default.createElement(RecoreCTA, {
    "data-cy": "recore-card-cta",
    ref: ctaRef,
    className: "recore-card-cta"
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    templateMap: {
      Link: _link.default
    },
    buttons: [cta]
  })));
}
var _default = exports.default = RecoreCard;
RecoreCard.propTypes = {
  cardSize: _propTypes.default.oneOf(['sm', 'lg']),
  icon: _propTypes.default.string,
  landscape: _propTypes.default.shape({
    url: _propTypes.default.string
  }),
  portrait: _propTypes.default.shape({
    url: _propTypes.default.string
  }),
  backgroundColor: _propTypes.default.shape({
    rgb: _propTypes.default.string,
    intent: _propTypes.default.string
  }),
  card: _propTypes.default.object,
  textFontSize: _propTypes.default.string,
  cta: _propTypes.default.shape({
    templateName: _propTypes.default.string,
    external: _propTypes.default.bool,
    design: _propTypes.default.string,
    as: _propTypes.default.string,
    ariaLabel: _propTypes.default.string,
    text: _propTypes.default.string.isRequired,
    href: _propTypes.default.string.isRequired,
    _name: _propTypes.default.string.isRequired
  })
};